import React, { useState } from "react";
import "./Alerts.css"; 
import Avatar from "../assets/Ellipse.png";

const alerts = [
  { 
    id: "1", 
    title: "Challenge Completed!", 
    description: "You successfully completed the 5K Run Challenge 🎉", 
    timestamp: "2025-02-13 10:30 AM", 
    image: Avatar 
  },
  { 
    id: "2", 
    title: "New Medal Earned!", 
    description: "You won a gold medal in the Monthly Steps Challenge 🏅", 
    timestamp: "2025-02-12 08:15 PM", 
    image: Avatar
  },
  { 
    id: "3", 
    title: "Workout Streak!", 
    description: "You have completed 7 days of workouts in a row! 💪", 
    timestamp: "2025-02-11 07:00 AM", 
    image: Avatar
  },
  { 
    id: "4", 
    title: "Hydration Reminder", 
    description: "Stay hydrated! Drink a glass of water now.💧", 
    timestamp: "2025-02-10 03:00 AM", 
    image: Avatar
  },
  { 
    id: "5", 
    title: "New Personal Best!", 
    description: "You ran your fastest mile today!🏃‍♂️", 
    timestamp: "2025-02-9 03:05 AM", 
    image: Avatar
  },
  { 
    id: "6", 
    title: "Mindfulness Achievement", 
    description: "You completed a 10-minute meditation session🧘‍♂️", 
    timestamp: "2025-02-8 03:10 AM", 
    image: Avatar
  },
  { 
    id: "7", 
    title: "Goal Reached!", 
    description: "You hit your daily step goal of 10,000 steps 🚶", 
    timestamp: "2025-02-7 03:15 AM", 
    image: Avatar
  },
];

const Alerts: React.FC = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState<any>(null);

  const openModal = (alert: any) => {
    setSelectedAlert(alert);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedAlert(null);
  };

  return (
    <div className="alerts-container">
      <div className="alerts-heading">
      <h2>Alerts</h2>
      </div>
      <ul className="alerts-list">
        {alerts.map(alert => (
          <li key={alert.id} className="alert-item">
            <img src={alert.image} alt={alert.title} className="alert-image" />
            <div className="alert-info">
              <div className="alert-title">{alert.title}</div>
              <div className="alert-timestamp">{alert.timestamp}</div>
            </div>
            <span className="alert-info-icon" onClick={() => openModal(alert)}>ℹ️</span>
          </li>
        ))}
      </ul>

      {isModalVisible && selectedAlert && (
        <div className="alert-modal-overlay" onClick={closeModal}>
          <div className="alert-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedAlert.image} alt={selectedAlert.title} className="alert-modal-image" />
            <h3>{selectedAlert.title}</h3>
            <p>{selectedAlert.description}</p>
            <p className="alert-modal-timestamp">{selectedAlert.timestamp}</p>
            <button className="alert-submit"onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Alerts;
